/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskPolicyApprovalsServerSetup = {
  /**
   * Whether the server joined the project's Default plugin, which republishes so agents that use the plugin get it.
   */
  addedToDefaultPlugin: boolean;
  /**
   * The approvals server Speakeasy created in the project.
   */
  mcpServerId: string;
  /**
   * The approvals server's slug.
   */
  mcpServerSlug: string;
  /**
   * How plugins name the server, and how held calls refer to it.
   */
  pluginServerName: string;
};

/** @internal */
export const RiskPolicyApprovalsServerSetup$inboundSchema: z.ZodMiniType<
  RiskPolicyApprovalsServerSetup,
  unknown
> = z.pipe(
  z.object({
    added_to_default_plugin: z.boolean(),
    mcp_server_id: z.string(),
    mcp_server_slug: z.string(),
    plugin_server_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "added_to_default_plugin": "addedToDefaultPlugin",
      "mcp_server_id": "mcpServerId",
      "mcp_server_slug": "mcpServerSlug",
      "plugin_server_name": "pluginServerName",
    });
  }),
);

export function riskPolicyApprovalsServerSetupFromJSON(
  jsonString: string,
): SafeParseResult<RiskPolicyApprovalsServerSetup, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPolicyApprovalsServerSetup$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPolicyApprovalsServerSetup' from JSON`,
  );
}
